interface Badge {
  id: number
  slug: string
  name: string
  emoji: string
  description: string
  category: string
  earned: boolean
  earned_at?: string
}

interface BadgesGridProps {
  badges: Badge[]
}

export function BadgesGrid({ badges }: BadgesGridProps) {
  const earned = badges.filter(b => b.earned)
  const locked = badges.filter(b => !b.earned)

  if (badges.length === 0) {
    return (
      <p className="text-gray-500 text-center py-8">
        Aucun badge disponible pour le moment.
      </p>
    )
  }

  return (
    <div className="space-y-6">
      {earned.length > 0 && (
        <div>
          <h3 className="text-sm font-medium text-gray-500 mb-3">
            Obtenus ({earned.length})
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
            {earned.map((badge) => (
              <BadgeCard key={badge.id} badge={badge} />
            ))}
          </div>
        </div>
      )}

      {locked.length > 0 && (
        <div>
          <h3 className="text-sm font-medium text-gray-500 mb-3">
            À débloquer ({locked.length})
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
            {locked.map((badge) => (
              <BadgeCard key={badge.id} badge={badge} />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

function BadgeCard({ badge }: { badge: Badge }) {
  return (
    <div
      className={`relative p-4 rounded-lg border text-center transition-all ${
        badge.earned
          ? 'bg-white border-green-500 shadow-sm'
          : 'bg-gray-50 border-gray-200 opacity-60'
      }`}
      title={badge.description}
    >
      <div className="text-3xl mb-2">{badge.emoji}</div>
      <div className="text-sm font-medium text-gray-900">{badge.name}</div>
      {badge.earned && badge.earned_at && (
        <div className="text-xs text-green-600 mt-1">
          {new Date(badge.earned_at).toLocaleDateString('fr-FR')}
        </div>
      )}
      {!badge.earned && (
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-4xl opacity-30">🔒</span>
        </div>
      )}
    </div>
  )
}
